import React from 'react';
import { PlateSubTitle, PlateTitle } from './styled';
import { Space } from '@gr-monorepo/common/ui';
import { Section } from '@gr-monorepo/common/models/gratitude';
import { sections } from './GratitudesPlateTemplates';
import { Gratitude, monthes } from './useGratitudes';
import ItemsRow from './ItemsRow';
import { useClickStreamContext } from 'features/shared/ClickStream';
import { Plate } from 'features/shared/ui/Page';
import LoaderComponent from 'features/shared/Loader';

export const GratitudesPlate = (
  props: React.PropsWithChildren<{
    section: Section;
    gratitudes: Record<number, Gratitude[]>;
    loading: boolean;
    isMunicipality: boolean;
  }>,
) => {
  const SectionTemplate = sections[props.section];
  const { logPageEvent } = useClickStreamContext();

  return (
    <Plate>
      <SectionTemplate
        isEmpty={!props.gratitudes || !Object.keys(props.gratitudes).length}
        loading={props.loading}
        isMunicipality={props.isMunicipality}
      >
        {props.loading && <LoaderComponent color={'#825AF7'} />}
        {monthes.map((el) =>
          props.gratitudes?.[el.monthIndex] ? (
            <>
              <ItemsRow
                key={el.month}
                title={el.month}
                cards={props.gratitudes?.[el.monthIndex] || []}
                logPageEvent={logPageEvent}
              />
              <Space size={24} axis="vertical" />
            </>
          ) : null,
        )}
      </SectionTemplate>
    </Plate>
  );
};
